<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Cihaz</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/create/cihaz"><button type="submit" class="btn submit bg-dark text-light">Yeni Cihaz</button>
          </router-link>
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Liste</button>
          </router-link>
          <router-link :to="`/rapor/cihaz/${id*8589}`"><button type="submit" class="btn submit bg-dark text-light">Rapor</button>
          </router-link>
          <router-link :to="`/update/cihaz/${id*8589}`"><button type="submit" class="btn submit bg-dark text-light">Güncelle</button>
          </router-link>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-4 col-12">
           <!-- <div class="row">
              <div class="col-12">
               <div class="pie-chart chart block">
                <apexchart type="radialBar" width="100%" :options="chartOptions" :series="series">
                </apexchart>
                </div>
              </div>
            </div>-->
            <div class="row">
              <div class="col-12">
               <div class="pie-chart chart block p-4">
                 <span style="font-size:18px">{{genel.alias}} {{genel.model}}</span> 
                </div>
                <div class="pie-chart chart block p-4">
                 <span style="font-size:18px"><span class="dashtext-3">{{genel.barkod}} </span> {{genel.cdalias}}</span> 
                </div>
                <div class="pie-chart chart block p-4">
                <span style="font-size:18px">{{genel.cariad+ ' - ' +genel.cdalias}}</span> 
                </div>
                <div class="pie-chart chart block p-4">
                <span style="font-size:18px"><span class="dashtext-3">{{$helper.trtgoster(genel.yas)}}</span> / Cihaz {{(parseInt($helper.gunhesapla(genel.yas)/365))}} Yaşında</span> 
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Aylara Göre İşlem ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="bar" width="100%" :options="durum.chartOptions" :series="durum.series"></apexchart>
                  </div>
                </div>
          </div>
        </div>
        <div class="row mt-2 mb-2 mr-2">
          <div class="col-lg-9 col-12">
            <button class="btn btn-outline-primary mr-2" @click="filter('All')">{{donem}}</button>
            <button class="btn btn-outline-secondary mr-2" v-for="(key,value) in this.$helper.groupByAdet(posts,'ay')"
            :key="value" @click="filter(value)">{{value}}</button>
          </div>
          <div class="col-lg-3 col-12 text-right">
              <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
          </div>
        </div>        
     <div class="row">
          <div class="col-12">
         <div class="block margin-bottom-sm">
            <div class="table-responsive"> 
               <table id="tablo" class="table table-striped">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Tarih</th>
                      <th>S.Nedeni</th>
                      <th>S.Durumu</th>
                      <th>S.Tipi</th>
                      <th>Guide</th>
                    </tr>
                  </thead>
                  <tbody>
                   <tr v-for="post in filteredItems(posts,'ay')" :key="post.id">
                    <td>{{post.no}}</td>
                    <td>{{trtgoster(post.tarih)}}</td>
                    <td>{{post.sn}}</td>
                    <td>{{post.sd}}</td>
                    <td class="dashtext-2">{{post.st}}</td>
                    <td>
                      <router-link :to="`/detay/servis/${post.fid * 8848+'bn'+post.said*8847+'sd'+post.bid*8846+'bn'+post.sid*8589+'bna3A15899hq34888egz301'}`">{{post.ariza_kodu}}</router-link>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
   
  </div>
</template>

<script>
export default {
   created() {  
     this.progres.inprogres = true
     this.yetki();
  },
  data () {
    return {
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        },      
      id : this.$route.params.id / 8589,
      posts : [],
      error :[],
      currentTag: 'All',
      donem : this.$request.donem(),
      ays:{},
      genel:{},
      durum : {},
      firma:this.$request.ayar().firmaid,
      kid:this.$request.ayar().kid,
      ya:this.$request.ayar.ya,
    }
  },
    methods : {

        yetki: function(){ // buradaki yetkilendirme değişecek bid de gelebilir sid de gelebilir.
  //      standart view servis yetkilendirmesi
          if (this.$helper.sayfayetki(227916)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){this.cihazgenel(this.id, this.getPostsAsync)}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },

      cihazgenel(id,servisler){
        this.$request.get("cihazgenel/"+id)
          .then(res => {
            this.genel = res.cihaz
            
          })
          servisler(id)
      },

        getPostsAsync(id){
         // this.$request.get("cihaz/"+this.ya+"/"+this.kid+"/"+id+'/'+this.donem)
         this.$request.get("detay/cihaz/"+id+'/'+this.donem)
          .then(res => {
            this.posts = res.results.sort((t1,t2) => t1.id < t2.id ? -1 : 1)
            this.aktarim(this.$helper.group2adet(res.results,'ay','st'))
            })
          .catch(err => {this.error.push(err)})
        },
        filter: function(tag) {
          this.currentTag = tag;
        },
        filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
        },
        aktarim (data){
          var datas = [];
          var aylar = [];
            Object.keys(data).forEach(function(key) {
              Object.keys(data[key]).forEach(function(keys) {
                    Object.keys(data[key][keys]).forEach(function(keysi) {
                      let deneme = {
                            name:key,
                            data: data[key][keys][keysi]
                        }
                        datas.push(deneme);
                        //aylar.push(data[key])
                  })
              })
            })
              const result = []
              datas.forEach(function (a) {
                  if ( !this[a.name] ) {
                      this[a.name] = { name: a.name, data:[]};
                      result.push(this[a.name]);
                  } 
                  this[a.name].data.push(a.data);
              //  
              }, Object.create(null));
                  this.durum = {
                    series: result,
                    chartOptions: {
                      colors: ["#ccc","#723ac3","#723ac3","#864DD9","#a678eb"],
                      chart: {
                        type: 'bar',
                        height: 350,
                        foreColor: '#a5a7ab',
                        toolbar: {show: false,}
                      },

                      xaxis: {
                        categories: ['Oca', 'Şub', 'Mar', 'Nis','May'],
                      },
                        fill: {
                      colors: ["#ccc","#723ac3","#723ac3","#864DD9","#a678eb"],
                        },                      
                      tooltip: {
                        y: {
                          formatter: function (val) {
                            return val
                          }
                        }
                      }
                    }
                  }
                  this.progres.inprogres = false

        },
        trtgoster(uzuntarih){
          const monthNames = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12" ];
          const d = new Date(uzuntarih);
          return d.getDate() +'-'+ monthNames[d.getMonth()]+'-'+d.getFullYear();
        }        
     }
   }
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "No"; }
		td:nth-of-type(3):before { content: "Tarih"; }
		td:nth-of-type(4):before { content: "S.Nedeni"; }
		td:nth-of-type(5):before { content: "S.Kod"; }
		td:nth-of-type(6):before { content: "S.Durumu"; }
		td:nth-of-type(7):before { content: "S.Tipi"; }
		td:nth-of-type(8):before { content: "Guide"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/cihaz/detay.vue